import React, { FC, useMemo, useState } from 'react';
import { getText } from '../../utilities/CultureUtilities';
import { CultureTextModel } from '../../models/form/form';
import TextInput from '../library/inputs/text/TextInput';
import _ from 'lodash';
import { Dropdown } from 'react-bootstrap';
import { addLanguageTouched, languageWarningsSelector } from '../../slices/formadmin';
import { useDispatch, useSelector } from 'react-redux';

interface Props {
  id: string;
  value: CultureTextModel[] | string;
  culture: string;
  onChange: (cultureText: CultureTextModel[]) => void;
  localizations: string[];
  rest?: Record<string, unknown>;
  [x: string]: unknown;
}

const CultureTextInput: FC<Props> = ({ id, value, culture, onChange, rest, localizations, ...remainingProps }) => {
  const dispatch = useDispatch();
  const languageWarnings = useSelector(languageWarningsSelector(id)) as any;
  const [selectedCulture, setSelectedCulture] = useState<string>(culture);
  const dropdownCultures = useMemo(
    () => _.filter(localizations, (localization) => localization != selectedCulture),
    [selectedCulture],
  );

  const hasWarnings = useMemo(() => {
    if (_.isEmpty(languageWarnings)) return false;

    let hasWarnings = false;
    for (const localization of localizations) {
      if (!languageWarnings[localization]) {
        hasWarnings = true;
      }
    }

    return hasWarnings;
  }, [languageWarnings]);

  return (
    <div className="culture-text d-flex align-items">
      {localizations.length > 1 && (
        <Dropdown>
          <Dropdown.Toggle>
            {selectedCulture}
            {hasWarnings && <span className="mdi mdi-alert alert-icon"></span>}
          </Dropdown.Toggle>

          <Dropdown.Menu>
            {dropdownCultures.map((localization) => (
              <Dropdown.Item key="localization" onClick={() => setSelectedCulture(localization)}>
                <div className="d-flex justify-content-between align-items-center">
                  <span className="culture-name">{localization}</span>
                  {!_.isEmpty(languageWarnings) && !languageWarnings[localization] && (
                    <span className="mdi mdi-alert alert-icon"></span>
                  )}
                </div>
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      )}
      <TextInput
        value={getText(value, selectedCulture)}
        onChange={(e) => {
          const newCultureText: CultureTextModel = { culture: selectedCulture, value: e.target.value };
          let newText: CultureTextModel[] = [];

          dispatch(addLanguageTouched({ id: id, culture: selectedCulture }));

          if (_.isArray(value)) {
            const index = _.findIndex(value, { culture: selectedCulture });
            if (index == -1) {
              newText = [...value, newCultureText];
            } else {
              newText = [...value];
              newText.splice(index, 1, newCultureText);
            }
          } else {
            newText = [newCultureText];
          }
          onChange(newText);
        }}
        rest={rest}
        {...remainingProps}
      ></TextInput>
    </div>
  );
};

export default CultureTextInput;
